import { Component, createRef } from 'react';
import Form, {
  GroupItem, SimpleItem, Label, EmptyItem,
} from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
import { appConst } from '~/app-const';

// Presentational dialog shown when an uploaded file name already exists.
// It is widget-agnostic: it reports the user's choice through `onResolve`
// ({ action: 'rename', newName } | { action: 'replace' } | { action: 'cancel' })
// and lets the caller decide how to perform the (re)upload.
export class FileDialogPopup extends Component {
  constructor(props) {
    super(props);
    this.fileDialogPopupRef = createRef();
    this.fileUploadFormRef = createRef();
  }

  uploadFileRadioGroupOptions = () => [
    "Rename the file I'm uploading",
    `Replace the existing file "${this.props.fileName}"${this.props.fileDate ? ` created on ${this.props.fileDate}` : ''}`,
  ];

  uploadFileOkButtonOptions = {
    text: 'Ok',
    icon: 'add',
    width: '150',
    onClick: () => {
      const form = this.fileUploadFormRef.current.instance();
      const selected = form.getEditor('NewFileNameOptions').option('value');
      const isRename = this.uploadFileRadioGroupOptions().indexOf(selected) === 0;
      if (isRename) {
        this.props.onResolve({ action: 'rename', newName: form.getEditor('NewFileName').option('value') });
      } else {
        this.props.onResolve({ action: 'replace' });
      }
    },
  }

  uploadFileCancelButtonOptions = {
    text: 'Cancel',
    icon: 'revert',
    width: '150',
    onClick: () => {
      this.props.onResolve({ action: 'cancel' });
    },
  }

  render() {
    const { visible, fileName, entityLabel } = this.props;
    return (
      <Popup
        ref={this.fileDialogPopupRef}
        visible={visible}
        {...appConst.defaultPopupOptions}
        height="auto"
        width={window.innerWidth * 0.6}
        showTitle={false}
      >
        <span>
          This
          {' '}
          {entityLabel || 'record'}
          {' '}
          already has a file named &ldquo;
          {fileName}
          &rdquo;. What do you want to do?
        </span>
        <Form ref={this.fileUploadFormRef}>
          <GroupItem caption=" " colCount={2}>
            <SimpleItem
              editorType="dxRadioGroup"
              dataField="NewFileNameOptions"
              editorOptions={{
                items: this.uploadFileRadioGroupOptions(),
                value: this.uploadFileRadioGroupOptions()[0],
                onValueChanged: (e) => {
                  const isRename = this.uploadFileRadioGroupOptions().indexOf(e.value) === 0;
                  this.fileUploadFormRef
                    && this.fileUploadFormRef.current
                    && this.fileUploadFormRef.current.instance().getEditor('NewFileName').option('disabled', !isRename);
                },
              }}
            />
            <SimpleItem editorType="dxTextBox" dataField="NewFileName" editorOptions={{ value: fileName, disabled: false }}>
              <Label text="New File Name" />
            </SimpleItem>
            <EmptyItem />
            <GroupItem caption=" " colCount={2} colSpan={3}>
              <SimpleItem
                itemType="button"
                horizontalAlignment="center"
                verticalAlignment="top"
                buttonOptions={this.uploadFileOkButtonOptions}
              />
              <SimpleItem
                itemType="button"
                horizontalAlignment="center"
                verticalAlignment="top"
                buttonOptions={this.uploadFileCancelButtonOptions}
              />
            </GroupItem>
          </GroupItem>
        </Form>
      </Popup>
    );
  }
}
